// Support API service
const AUTH_API_BASE =
  import.meta.env.VITE_AUTH_API_URL || "http://localhost:8081";

export interface SupportContactRequest {
  name: string;
  email: string;
  phone?: string;
  preferred_contact: "email" | "phone" | "either";
  issue_type: "bug" | "feature_request" | "question" | "account" | "other";
  subject: string;
  message: string;
  user_id?: string;
}

export interface SupportContactResponse {
  success: boolean;
  message: string;
}

export interface SupportValidationError {
  error: string;
  details?: string[];
}

export async function submitSupportRequest(
  request: SupportContactRequest
): Promise<SupportContactResponse> {
  const response = await fetch(`${AUTH_API_BASE}/api/v1/support/contact`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request),
  });

  const data = await response.json();

  if (!response.ok) {
    const errorData = data as SupportValidationError;
    throw new Error(errorData.details?.join(", ") || errorData.error || "Request failed");
  }

  return data as SupportContactResponse;
}
